export default __webpack_public_path__ + "static/media/Integraciones.bf2f44c9.png";